import React, {useState} from 'react'
import Spinner from '../Spinner/Spinner'
import { Getter, Setter } from '../../services/ComService'
import mainservice from '../../services/MainService'
import { i18n } from '../../services/i18n'

enum Status {
  start,
  loading,
  success,
  error
}

function UserEndorse() {
  const [status, setStatus] = useState(Status.start)
  const session = mainservice.nav.getVal('session')
  const content = () => {
    switch(status) {
      case Status.start:
        return <div className='w3-container'>
            <div className='lu-headline'>{i18n('endorseHeadline')}</div>
            <p>{i18n('endorseDescription')}</p>
            <button
              className='w3-btn w3-ripple register-button'
              onClick={async () => {
                setStatus(Status.loading)
                const result: {status: string} | any = await Setter('user/endorse', {
                  hash: session
                }, {retryName: `${session}`})
                if (result && result.status === 'okay') {
                  setStatus(Status.success)
                  return
                }
                setStatus(Status.error)
              }}
            >{i18n('endorseButton')}</button>
          </div>
      case Status.loading:
        return <div className='w3-container'>
            <div className='lu-headline'>{i18n('endorseHeadline')}</div>
            <p>{i18n('endorseInProgress')}</p>
            <p className='w3-center'><Spinner
            mini={true}
            sizeClass='normalSize'
            /></p>
          </div>
      case Status.success:
        return <div className='w3-container'>
            <div className='lu-headline'>{i18n('endorseReceived')}</div>
            <p>{i18n('endorseThanksForYourEndorsement')}</p>
            <p className='w3-center fontSize8'>👍</p>
            <p>{i18n('endorseThanksForYourEndorsement2')}</p>
            <p className='w3-center fontSize8'>⏳</p>
          </div>
      case Status.error:
        return <div className='w3-container'>
            <div className='lu-headline'>{i18n('endorseError')}</div>
            <p className='w3-center fontSize8'>🙁</p>
            <p>{i18n('endorseErrorHint')} <a href="mailto:digital@lubbers.de">digital@lubbers.de</a></p>
          </div>
    }
  }
  return <div className='w3-row'>
    <div className="w3-col l4 m3 s0">&nbsp;</div>
    <div className='w3-card-4 lu-dialog w3-col l4 m6 s12'>
      { content() }
    </div>
  </div>
}

export default UserEndorse
